// Module
var code = "<ul> <li><a href=\"\">Home</a></li> <li><a href=\"demo\">Demo</a></li> <li><a href=\"tutorial\">Tutorial</a></li> <li><a href=\"documentation\">Documentation</a></li> </ul> ";
// Exports
export default code;